export const initialState = () => ({
  planUuidEditing: false,
  planAlreadyFetchEditing: false,
  planName: "",
  planCommercialName: "",
  planCategoriesOptions: [],
  planCategorySelected: "",
  planPrice: "0,00",
  planMovementsOptions: [],
  planMovementSelected: [],
  planScore: null,
  planPhysicalPerson: false,
  planLegalPerson: false,
  planActive: false,
  planRecommended: false,
  planShouldBeDisplayed: false,
  planIcon: [],
  planIconPreview: {
    url: "",
    icon: ""
  },
  planRelatedPackages: 0,
  planCreatedThrough: "",

  planSvasOptions: [],
  planSvasSelecteds: [],
  planSvasOptionsAlreadySelecteds: [],

  planCampaignOptions: [],
  planCampaignSelecteds: [],

  planCoverageOptions: [],

  planCoverageStateOptions: [],
  planCoverageStatesSelecteds: [],

  planCoverageCityStateOptions: [],
  planCoverageCityStateSelected: "",
  planCoverageCityOptions: [],
  planCoverageCitySelecteds: [],

  planCoverageDddOptions: [],
  planCoverageDddsSelecteds: [],

  planDiscountOptions: [],
  planDiscountTypes: {},

  planDiscountPaymentOptions: [],
  planDiscountPaymentSelecteds: [],

  planDiscountShippingOptions: [],
  planDiscountShippingSelecteds: [],

  planAccessOptions: [],

  planAccessChainOptions: [],
  planAccessChainsSelecteds: [],

  planAccessPosOptions: [],
  planAccessPosSelecteds: [],

  hasAdditionalConfig: false,
  freeAdditionalQuantity: null,
  paidAdditionalQuantity: null,
  additionalUnitPrice: null,
})
